(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-slider]').forEach(function (root) {
    // L'anteprima reinnesta gli <script> a ogni cambio di rotta: senza questo
    // segno lo stesso slider partirebbe con due intervalli sovrapposti.
    if (root.hasAttribute('data-slider-ready')) return;
    root.setAttribute('data-slider-ready', '');

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-goto]'));
    if (slides.length < 2) return;

    var index = 0;
    var timer = null;
    var delay = parseInt(root.getAttribute('data-autoplay'), 10) || 7000;

    // Il video della slide attiva parte; gli altri restano fermi al poster,
    // così una sola decodifica alla volta e nessuno scarico inutile.
    function syncVideo() {
      slides.forEach(function (slide, i) {
        var video = slide.querySelector('[data-hero-video]');
        if (!video) return;
        if (i === index) {
          if (video.preload !== 'auto') video.preload = 'auto';
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    function show(next) {
      slides[index].classList.remove('is-active');
      if (dots[index]) dots[index].setAttribute('aria-selected', 'false');
      index = (next + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      if (dots[index]) dots[index].setAttribute('aria-selected', 'true');
      syncVideo();
    }

    function start() {
      if (reduced || timer) return;
      timer = setInterval(function () { show(index + 1); }, delay);
    }
    function stop() { clearInterval(timer); timer = null; }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stop();
        show(parseInt(dot.getAttribute('data-goto'), 10));
        start();
      });
    });

    function jump(step) {
      stop();
      show(index + step);
      start();
    }

    var prev = root.querySelector('[data-slide-prev]');
    var next = root.querySelector('[data-slide-next]');
    if (prev) prev.addEventListener('click', function () { jump(-1); });
    if (next) next.addEventListener('click', function () { jump(1); });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { jump(-1); }
      if (event.key === 'ArrowRight') { jump(1); }
    });

    // Swipe da mobile. Soglia a 45px e vincolo sull'asse: sotto quella
    // distanza, o se il gesto è più verticale che orizzontale, è uno scroll.
    var startX = 0;
    var startY = 0;
    var tracking = false;
    root.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      tracking = true;
      stop();
    }, { passive: true });
    root.addEventListener('touchend', function (event) {
      if (!tracking) return;
      tracking = false;
      var touch = event.changedTouches[0];
      var dx = touch.clientX - startX;
      var dy = touch.clientY - startY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
        show(index + (dx < 0 ? 1 : -1));
      }
      start();
    }, { passive: true });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      // Tornando visibili il browser lascia il video in pausa: lo si riavvia
      // a mano, altrimenti la slide resta ferma sul poster.
      if (document.hidden) { stop(); } else { start(); syncVideo(); }
    });

    syncVideo();
    start();
  });
})();
